import React from 'react'

import './fonts/iconfont'
import './index.less'

export { default as iconList } from '../icon-list'

export default ({ type, prefix = 'tnt-', className = '', ...props }) => {
  return (
    <i className={`tnt-icon ${className}`} type={type} {...props}>
      <svg aria-hidden="true">
        <use xlinkHref={`#${prefix}${type}`} />
      </svg>
    </i>
  )
}
